import { LockOutlined } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'

// import '@ant-design/compatible/assets/index.css';

import { Input, Modal } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import '../styles/Modal.css'

class EditProfileModal extends React.Component {
  state = {
    showPassword: false,
  }

  togglePassword = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }))
  }

  update = () => {
    this.form.validateFields((err, values) => {
      if (!err) {
        const { user, userActions } = this.props
        userActions.updateUserProfile(user.email, {
          name: values.name,
          phone: values.phone,
          company: values.company,
        })

        if (values.password) {
          userActions.changePassword(
            user.email,
            values.oldpassword,
            values.password,
          )
        }
      }
    })
  }

  saveFormRef = (ref) => (this.form = ref)

  render() {
    return (
      <Modal
        title="Edit Profile"
        okText="SAVE"
        onOk={() => this.update()}
        cancelText="Cancel"
        onCancel={this.props.modalActions.closeModal}
        open={this.props.modal.modalOpen}
        confirmLoading={this.props.appState.asyncPending}
        maskClosable={false}
      >
        <div className="modal__body">
          <EditProfileForm
            name={this.props.user.name}
            email={this.props.user.email}
            phone={this.props.user.phone || ''}
            company={this.props.user.company || ''}
            ref={this.saveFormRef}
            showPassword={this.state.showPassword}
            togglePassword={this.togglePassword}
          />
        </div>
      </Modal>
    )
  }
}

const EditProfileForm = Form.create()((props) => {
  const { form } = props
  const { getFieldDecorator } = form
  const clearError = (e) => {
    if (props.form.getFieldError(e.target.id))
      props.form.setFields({ [e.target.id]: { errors: '' } })
  }

  return (
    <Form layout="vertical">
      <Form.Item label="Name" require={true}>
        {getFieldDecorator('name', {
          initialValue: props.name,
          rules: [
            {
              required: true,
              message: 'Name is required',
            },
          ],
        })(<Input />)}
      </Form.Item>
      <Form.Item label="Email">
        {getFieldDecorator('title', {
          initialValue: props.email,
        })(<Input disabled />)}
      </Form.Item>
      <Form.Item label="Phone">
        {getFieldDecorator('phone', {
          initialValue: props.phone,
        })(<Input />)}
      </Form.Item>
      <Form.Item label="Company">
        {getFieldDecorator('company', {
          initialValue: props.company,
        })(<Input />)}
      </Form.Item>
      {props.showPassword ? (
        <div>
          <Form.Item label="Old Password">
            {getFieldDecorator('oldpassword', {
              initialValue: '',
              onChange: clearError,
              rules: [
                {},
                {
                  validator(rule, value, callback) {
                    if (
                      props.form.getFieldValue('password') &&
                      value.length < 8
                    ) {
                      return callback(new Error('Old Password is required'))
                    } else return callback()
                  },
                },
              ],
            })(
              <Input
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="Password"
              />,
            )}
          </Form.Item>
          <Form.Item label="New Password">
            {getFieldDecorator('password', {
              validateTrigger: 'onBlur',
              onChange: clearError,
              rules: [
                {},
                {
                  validator(rule, value, callback) {
                    if (value && value.length < 8) {
                      return callback(
                        new Error('Password must be at least 8 characters'),
                      )
                    } else return callback()
                  },
                },
              ],
            })(
              <Input
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="New Password"
              />,
            )}
          </Form.Item>
          <Form.Item label="Confirm Password">
            {getFieldDecorator('confirmpassword', {
              validateTrigger: 'onBlur',
              onChange: clearError,
              rules: [
                {},
                {
                  validator(rule, value, callback) {
                    if (
                      props.form.getFieldValue('password') &&
                      (!value ||
                        value.length < 8 ||
                        value !== props.form.getFieldValue('password'))
                    )
                      return callback(new Error('Passwords must match'))
                    else return callback()
                  },
                },
              ],
            })(
              <Input
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="Confirm Password"
              />,
            )}
          </Form.Item>
        </div>
      ) : (
        <div className="modal__link" onClick={props.togglePassword}>
          Change Password
        </div>
      )}
    </Form>
  )
})

EditProfileModal.propTypes = {
  user: PropTypes.object,
  userActions: PropTypes.object,
  modal: PropTypes.object,
  modalActions: PropTypes.object,
}

export default EditProfileModal
